module.exports = __webpack_public_path__ + "media/pop-up.c8a4b3ed.wav";